import * as React from "react"
import { Box } from "@mui/material"

import SchedulesTable from "./Table"
import CreateScheduleDrawer from "./CreateScheduleDrawer"
import EditScheduleDrawer from "./EditScheduleDrawer"


export default function SchedulesPage() {
    return (
        <Box>
            <SchedulesTable />
            <CreateScheduleDrawer />
            <EditScheduleDrawer />
        </Box>
    )
}
